import { Box, Grid, Stack } from '@mantine/core';
import { FC } from 'react';
import { useParams } from 'react-router-dom';
import { InputText } from 'src/components/Form/Text';
import { InputFile } from 'src/components/Form/File';
import { PageTitle } from 'src/components/PageTitle';
import { Form } from 'src/form';

import { useAddTheme } from './use-add-theme';
import { useGetInteractionDictionaryQuery } from 'src/api/interactions-dictionary';
import { ActionFooter } from 'src/components/ActionFooter';

export const AddTheme: FC = () => {
  const { dictionaryId } = useParams<{ dictionaryId: string }>();
  const { isPending, handleSubmit, initialValues, validate, handleCancel } =
    useAddTheme();
  const { data: dictionaries } = useGetInteractionDictionaryQuery(
    Number(dictionaryId)
  );

  return (
    <Form
      initialValues={initialValues}
      validate={validate}
      onSubmit={handleSubmit}
    >
      <Box
        display="flex"
        style={{
          flexDirection: 'column',
          height: '100%',
          justifyContent: 'space-between',
        }}
      >
        <Stack gap="lg">
          <PageTitle title={`Add Theme for:  ${dictionaries?.name}`} />
          <Grid>
            <Grid.Col span={5}>
              <Stack>
                <InputText
                  name="name"
                  label="Theme Name"
                  placeholder="Enter theme name"
                  maxLength={50}
                />
                <InputText
                  name="theme_id"
                  label="Theme ID (for Unity)"
                  placeholder="Enter theme ID"
                  type="number"
                />
              </Stack>
            </Grid.Col>
          </Grid>

          <Grid>
            <Grid.Col span={3}>
              <InputFile
                width={270}
                height={480}
                name="image"
                label="Theme Preview Image"
              />
            </Grid.Col>
          </Grid>
        </Stack>

        <ActionFooter
          isLoading={isPending}
          onCancel={handleCancel}
          submitButton="CREATE"
        />
      </Box>
    </Form>
  );
};
